export enum eContactType {
  Person = 'PERSON',
  Signatory = 'SIGNATORY',
  ClientContact = 'CLIENT_CONTACT',
  LenderContact = 'LENDER_CONTACT',
  ThirdPartyContact = 'THIRD_PARTY_CONTACT',
  None = 'NONE',
}
